import React, { useState,useEffect } from "react";
import {
  Button,
  Container
} from "reactstrap";
import OtpInput from '../OtpInput/IndexOtpInput';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { otpSend, otpResend, otpVerify, register, checkExit, addEvaluation } from '../../actions'
import { adminAction } from "actions/adminAction";

import { updateNoteApplicationBySupervisor } from "actions/adminAction";


// core components
function UpdateApplyNoteBySupervisor({
  token,
  item,
  onSuccess
}) {


  
  useEffect(() => {
    if (item) {
      setMessage(item.apply_note);
    }
  }, [token]);
  const [message, setMessage] = useState('');

  
  const handleMessageChange = event => {
  
    item.apply_note = event.target.value;
    setMessage(event.target.value);
  };

  

  

  const _onSubmit = (data,token) => {
    updateNoteApplicationBySupervisor(data,token).then((res) => {
      if (res) {
        var index = res.toString().indexOf("Error:")
        if (index == -1) {
          let token = res.data
          const data = {
            
          }
          onSuccess(true)
        } else {
          onSuccess(false)
        }
      } else {

      }
    }).catch((error) => {

    })
  }

  return (
    <Container>
      <div>
        <Formik
          initialValues={item}
          onSubmit={(e) => _onSubmit(e,token)}
        >
          {({ errors, touched, handleSubmit, handleReset, setFieldValue }) => (
            <Form onSubmit={handleSubmit} onReset={handleReset}>
              <div className="form-group">
                <label htmlFor="message" >
                  Note
                </label>
                <textarea class="form-control" id="message" rows="10"
                    
                     name="message"
                     value={message}
                     onChange={handleMessageChange}

                    >
                </textarea>
              </div>
             
             
              <div className="row">
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <Button type="submit" className="btn-round" color="info" style={{ width: '80%' }}>บันทึก</Button>
                </div>
                
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}

export default UpdateApplyNoteBySupervisor;
